import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vufm7w6mfr: FaireBrandEntity = {
  token: "b_vufm7w6mfr",
  type: "brand",
  name: "BRIXY",
  avatarUrl:
    "https://cdn.faire.com/fastly/64f720c59bb6bed2c2874b8f6fe82cfbc08bee97f91d410c94428faf73e79bc2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0c01158389fa7fb31b83159156bd78c0c0b276ddb0837598729ad0902785264a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/64f720c59bb6bed2c2874b8f6fe82cfbc08bee97f91d410c94428faf73e79bc2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0c01158389fa7fb31b83159156bd78c0c0b276ddb0837598729ad0902785264a.png",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "Elevating conscious beauty that's better for you with safe, gentle, and effective solutions for hair and skin while making it better for the planet with zero plastic packaging. \n\nDrawing on 20+ years of experience building safe and effective products, we are the same team that brought Thinkbaby & Thinksport to market. After being acquired in 2020, we created BRIXY with the goal to revolutionize sustainable personal care. In keeping with our heritage of safe ingredients, we've layered in our love for the planet with a line of 100% plastic free personal care products. We believe exceptional and effective daily essentials don't have to come in plastic packaging.\n\nOur entire line is focused on supporting a strong moisture barrier with our ceramide and niacinamide complex. Your scalp and underarms are skin too, so we treat them just as well! The skin and hair barrier is our first line of defense against environmental stressors that can cause sensitivity, dryness, breakage and other unwanted skin conditions. Using ingredients clinically proven to protect, repair and prevent damage, our BRIXY Blend can be found in the base of every product we offer.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:37.629Z",
    importedBy: "entity-db-cli",
  },
};
